import { ModuleOverview } from 'types/module';
import { ImageSection } from './ImageSection/ImageSection';
import { ContentSection } from './ContentSection/ContentSection';
import { TagCompleted } from './ProgressTags/Completed/TagCompleted';
import { BarCompleted } from './ProgressBars/Completed/BarCompleted';
import { TagInProgress } from './ProgressTags/InProgress/TagInProgress';
import { PartialProgressBar } from './ProgressBars/InProgress/PartialProgressBar';

import './ModuleCard.scss';
import { useNavigateToModule } from './useNavigateToModule';
import { ComingSoonTag } from './ProgressTags/ComingSoon/ComingSoonTag';
import { TagHidden } from './ProgressTags/Hidden/TagHidden';
import { useMemo } from 'react';

type Props = {
  module: ModuleOverview;
  isAdmin: boolean;
};

export const ModuleCard = ({ module, isAdmin }: Props) => {
  const navigateToModule = useNavigateToModule(module.slug);

  const navigate = () => {
    if (module.status !== 'ComingSoon' || isAdmin) {
      navigateToModule();
    }
  };

  const card = useMemo(() => {
    if (module.status === 'Hidden' && isAdmin) {
      return HiddenCard(module);
    } else if (module.status == 'ComingSoon') {
      return ComingSoonCard(module, isAdmin);
    } else if (module.progress === 100) {
      return CompletedCard(module);
    } else if (module.progress > 0) {
      return InProgressCard(module);
    } else {
      return NotStartedCard(module);
    }
  }, [module, isAdmin]);

  return (
    <>
      <div className={module.status == 'ComingSoon' && !isAdmin ? 'module-card' : 'module-card  module-card__enabled'} onClick={navigate}>
        {card}
      </div>
    </>
  );
};

const NotStartedCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module} />
    <ContentSection {...module} />
  </>
);

const ComingSoonCard = (module: ModuleOverview, isAdmin: boolean) => (
  <>
    <ImageSection {...module} isAdmin={isAdmin}>
      <ComingSoonTag isAdmin={isAdmin} />
    </ImageSection>
    <ContentSection {...module} isAdmin={isAdmin} />
  </>
);

const CompletedCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module}>
      <TagCompleted />
    </ImageSection>
    <ContentSection {...module}>
      <BarCompleted />
    </ContentSection>
  </>
);

const InProgressCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module}>
      <TagInProgress progress={module.progress} />
    </ImageSection>
    <ContentSection {...module}>
      <PartialProgressBar progress={module.progress} />
    </ContentSection>
  </>
);

const HiddenCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module}>
      <TagHidden />
    </ImageSection>
    <ContentSection {...module} />
  </>
);
